import React from 'react';
import { Link } from 'react-router-dom';
import './CSS/OrderSuccess.css'; // Create a simple CSS file for styling

const OrderSuccess = () => {
    return (
        <div className="order-success-container">
            <div className="order-success-card">
                <h2>Payment Successful!</h2>
                <p>Thank you for your order. We have received your payment and will begin processing your order shortly.</p>
                <p>A confirmation email has been sent to you.</p>
                <Link to="/" className="continue-shopping-btn">Continue Shopping</Link>
            </div>
        </div>
    );
};

export default OrderSuccess;